import { DictionaryCurrencyForm as DictionaryCurrencyFormDefinition } from "./DictionaryCurrencyForm";

export const DictionaryCurrencyForm = DictionaryCurrencyFormDefinition;
